import { InternationalizationService } from '@services/utils/internationalization/internationalization.service';
import { SessionService } from '@services/utils/session.service';

import { ca, de, enUS, es, eu, fr, it, pt, ptBR } from 'date-fns/locale';
import { ca_ES, de_DE, en_US, es_ES, fr_FR, gl_ES, it_IT, pt_BR, pt_PT } from 'ng-zorro-antd/i18n';

export function getLanguage(internationalizationService: InternationalizationService): string {
    let language: string = internationalizationService.getLanguage();
    if (language.toLowerCase() === 'eu_es') {
        language = 'es_ES';
    }

    return toAngularLocaleId(language);
}

function toAngularLocaleId(language: string): string {
    const normalized = language.replace('_', '-');
    const [lang, region] = normalized.split('-');
    if (!region) {
        return lang.toLowerCase();
    }

    return `${lang.toLowerCase()}-${region.toUpperCase()}`;
}

export function getFirstDayOfWeek(internationalizationService: InternationalizationService): any {
    return { firstDayOfWeek: internationalizationService.getFirstDayOfWeek() };
}

export function getCurrencyCode(sessionService: SessionService): string {
    return sessionService.getCenterInfo() ? sessionService.getCenterInfo().currencyCode : 'EUR';
}

export function getLocale(internationalizationService: InternationalizationService): any {
    let language: any;
    switch (internationalizationService.getLanguage().toLowerCase()) {
    case 'es_es':
        language = es_ES;
        break;
    case 'en_us':
        language = en_US;
        break;
    case 'de_de':
        language = de_DE;
        break;
    case 'fr_fr':
        language = fr_FR;
        break;
    case 'pt_pt':
        language = pt_PT;
        break;
    case 'ca_es':
        language = ca_ES;
        break;
    case 'pt_br':
        language = pt_BR;
        break;
    case 'eu_es':
        language = es_ES;
        break;
    case 'it_it':
        language = it_IT;
        break;
    case 'gl_es':
        language = gl_ES;
        break;
    case 'en_au':
        language = en_US;
        break;
    case 'es_mx':
        language = es_ES;
        break;
    case 'es_ar':
        language = es_ES;
    }

    return language;
}

export function getDateFns(internationalizationService: InternationalizationService): Locale {
    let dateFnsLocale: Locale = es;
    switch (internationalizationService.getLanguage().toLowerCase()) {
    case 'es_es':
        dateFnsLocale = es;
        break;
    case 'en_us':
        dateFnsLocale = enUS;
        break;
    case 'de_de':
        dateFnsLocale = de;
        break;
    case 'fr_fr':
        dateFnsLocale = fr;
        break;
    case 'pt_pt':
        dateFnsLocale = pt;
        break;
    case 'ca_es':
        dateFnsLocale = ca;
        break;
    case 'pt_br':
        dateFnsLocale = ptBR;
        break;
    case 'eu_es':
        dateFnsLocale = eu;
        break;
    case 'it_it':
        dateFnsLocale = it;
        break;
    case 'gl_es':
        dateFnsLocale = es;
        break;
    case 'en_au':
        dateFnsLocale = enUS;
        break;
    case 'es_mx':
        dateFnsLocale = es;
        break;
    case 'es_ar':
        dateFnsLocale = es;
        break;
    }

    return dateFnsLocale;
}

